export const ADD_TAG = "ADD_TAG";
export const UPDATE_TAG = "UPDATE_TAG";
export const REMOVE_TAG = "REMOVE_TAG";

export const addTag = (tag) => {
  return {
    type: ADD_TAG, 
    tag
  }
}

export const updateTag = (tag, index) => {
  return {
    type: UPDATE_TAG, 
    tag,
    index
  }
}

export const removeTag = (index) => {
  return {
    type: REMOVE_TAG, 
    index
  }
}


// WEBPACK FOOTER //
// ./src/actions/tags.js